<template>
  <div class="table-container">
    <div class="row justify-between">
      <h3 class="table-container__heading">{{ $t("cash") }}</h3>
      <div class="table-container__controls controls">
        <date-picker
          :lang="$t('short lang')"
          :confirm="true"
          class="controls__item controls__date-picker"
          value-type="format"
          v-model="toDate"
          @change="handleDatePickerChange"
          :clearable="false"
          :placeholder="$t('select date')"
          :not-after="new Date()"
          format="DD.MM.YYYY"
        />
        <!--                :value="incomeDateRange"-->
        <input
          v-model="searchQuery"
          type="search"
          class="controls__item controls__search"
          :placeholder="$t('search')"
        />
      </div>
    </div>
    <br />
    <div
      style="position: relative;"
      v-show="isTableLoading"
      class="table__preloader"
    >
      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
    </div>
    <div v-if="!isTableLoading" style="min-height: 300px;">
      <div v-if="isMultipleTypes" class="menu-buttons">
        <button
          class="menu-button"
          :class="{ active: value.selected }"
          v-for="(value, key, index) in cash_data.types"
          @click="selectCashDataType(index)"
        >
          {{ key }}
        </button>
      </div>
      <table class="table-container__table table" style>
        <thead>
          <tr>
            <td class="table__head" style="width: 25%">
              {{ $t("holder name") }}
            </td>
            <td class="table__head">{{ $t("acc type") }}</td>
            <td class="table__head">{{ $t("bank account") }}</td>
            <td class="table__head align-right">{{ $t("summ") }}</td>
            <td v-if="isUserVIP" class="table__head align-center">
              {{ $t("interest charges") }}
            </td>
            <td class="table__head align-center">{{ $t("currency") }}</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="cash in cash_data.selected.list"
            :key="String(cash.BANK_ACCOUNT)"
          >
            <td class="table__body" style="overflow-x: hidden">
              {{ cash.HOLDER_NAME }}
            </td>
            <td>{{ cash.ACCTYPE }}</td>
            <td class="table__body">{{ cash.BANK_ACCOUNT }}</td>
            <td class="table__body align-right">
              {{ formatMoney(cash.AMOUNT) }}
            </td>
            <td v-if="isUserVIP" class="table__body align-center">
              {{ formatMoney(cash.INCOME) }}
            </td>
            <td class="table__body align-center">{{ cash.CUR_CODE }}</td>
          </tr>
        </tbody>
      </table>
      <div class="total" v-if="cash_data.selected">
        <span>{{ $t("total") }}:</span>
        <span>
          {{ $formatMoney(cash_data.selected.total[getSelectedCurrency]) }}
          {{ getCurrencySignByTicker(getSelectedCurrency) }}
          <br />
        </span>
        <span
          class="total_sub_price"
          v-for="(price, key) in cash_data.selected.total"
        >
          <span v-if="key != getSelectedCurrency"
            >{{ getCurrencySignByTicker(key) }} {{ $formatMoney(price) }}</span
          >
        </span>
        <br />
        <span style="font-size: 11px;color: #888787;"
          >по курсу на {{ toDate }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import DatePicker from "vue2-datepicker";
import { replaceCommas, formatMoney, income } from "@/helpers/money";
import { isLoading } from "@/helpers/loading";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    spinner: HalfCircleSpinner,
    "date-picker": DatePicker
  },
  data() {
    return {
      searchQuery: "",
      cash_data_list: null,
      cash_data_total: null,
      toDate: moment().format("DD.MM.YYYY")
    };
  },
  computed: {
    isMultipleTypes() {
      return Object.keys(this.cash_data.types).length > 1;
    },
    isTableLoading() {
      return isLoading(this.userCash);
    },
    // filteredUserCash() {
    //   // Перехватываем начальное сотояние null, а также другие ошибки
    //   if (!this.cash_selected_data) {
    //     return [];
    //   }
    //   // Фильтруем массив по строке поиска
    //   return this.cash_selected_data.cash.filter(
    //     item =>
    //       !item.HOLDER_NAME.toLowerCase().indexOf(
    //         this.searchQuery.toLowerCase()
    //       )
    //   );
    // },
    ...mapGetters([
      "userCash",
      "displayingCurrency",
      "currencySign",
      "rate",
      "getCashData",
      "getCurrencySignByTicker",
      "getSelectedCurrency",
      "isUserVIP"
    ]),
    ...mapGetters({
      cash_data: "getCashTableData"
    })
  },
  methods: {
    formatMoney,
    selectCashDataType(index) {
      this.$store.commit("cashDataSetSelectedIndex", index);
    },
    getIncome(amount, dealAmount) {
      return income(replaceCommas(amount), replaceCommas(dealAmount));
    },

    // Возвращаем класс для окраски блока в зависимости от дохода (красный - убыток, зеленый - доход)
    getIncomeColor(income) {
      if (Math.sign(income) === 1) {
        return "table__body_green";
      } else if (Math.sign(income) === -1) {
        return "table__body_red";
      }
    },
    handleDatePickerChange(date) {
      this.$store.dispatch("changeToDate", date);
      //   // Очищаем данные о доходности, чтобы отобразить лоадер
      //   this.$store.dispatch("clearIncomeData");
      //   // Отправляем новую дату в глобальное хранилище
      //   this.setSelectedDateRange(dateRange);
      //   // Загружаем данные о доходности на основе выбранного промежутка даты
      //   this.$store.dispatch("fetchIncomeData");
      // },
      // // Устанавливаем дату в глобальное хранилище
      // setSelectedDate(date) {
      //   this.$store.dispatch("setIncomeDateRange", date);
    }
  },
  mounted() {
    // Если портфель еще не был загружен, то загружаем его
    this.$store.dispatch("fetchUserCash");
  }
};
</script>

<style scoped>
.menu-buttons {
  margin-bottom: 10px;
}
.menu-buttons .menu-button {
  display: inline-block;
  margin-right: 10px;
  padding: 8px 10px;
  border: 2px solid #1a75e9;
  border-radius: 5px;
  font-size: 16px;
}
.menu-buttons .menu-button.active {
  background-color: #1a75e9;
  color: white;
}
.total {
  text-align: right;
  font-size: 20px;
  margin: 55px;
}
.total_sub_price {
  font-size: 14px;
}
.total span {
  padding: 5px;
}
.table-container {
  padding: 30px 30px 0;
}

.table-container__heading {
  font-size: 36px;
  font-weight: normal;
}

.table-container__select:not(:first-child) {
  margin-left: 15px;
}

.table {
  position: relative;
  margin: 40px 0 0;
}
.table__body {
  font-size: 14px;
}
.table__body:first-child,
.table__head:first-child {
  padding-left: 0px;
}
.table__preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.controls {
  height: 39px;
}

.controls__item {
  height: 100%;
  padding: 0 12px;
  font-size: 15px;
  background-color: #ffffff;
  border: 1px solid #acb5c5;
  border-radius: 5px;
  outline: none;
}

.controls__date-picker {
  border: none;
}

@media all and (max-width: 1600px) {
  .table-container {
    padding: 30px 25px 0;
  }
}
@media all and (max-width: 1200px) {
  .table-container {
    padding: 20px 15px 0;
  }
  .title {
    font-size: 26px;
  }
  .table__body {
    font-size: 12px;
  }
  .table__head {
    font-size: 12px;
  }
}
</style>
